import { signal } from "@preact/signals-react";

export const totalPoints = signal(0)